import { Box, Stack, Typography } from "@mui/material";
import { useState } from "react";
import DynamicIcon from "@entrilia/shared/components/DynamicIcon";
import SearchField from "@entrilia/shared/components/inputs/SearchField";
import IconGrid from "./IconGrid";
import { buildIconOptions } from "./iconOptions";

interface Props {
  categoryName: string;
  value: string;
  onChange: (iconName: string) => void;
}

const IconPicker = ({ categoryName, value, onChange }: Props) => {
  const [pinnedIconName] = useState(value);
  const [options, setOptions] = useState(() => buildIconOptions(pinnedIconName, ""));

  const handleSearch = (searchTerm: string) => setOptions(buildIconOptions(pinnedIconName, searchTerm));

  return (
    <Stack spacing={1.5}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center", color: "text.secondary" }}>
        <Typography>Menu Preview:</Typography>
        <Box sx={{ width: 20, flexShrink: 0 }}>
          <DynamicIcon iconName={value} />
        </Box>
        <Typography variant="subtitle2">{categoryName}</Typography>
      </Stack>

      <SearchField fullWidth debounceTimeMs={300} placeholder="Search icons" onSearch={handleSearch} />

      <Box sx={{ height: "16rem", overflowY: "auto", p: 1.25, border: 1, borderColor: "divider", borderRadius: 2 }}>
        <IconGrid options={options} selectedIconName={value} onChange={onChange} />
      </Box>
    </Stack>
  );
};

export default IconPicker;
